import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=0d8b5473&scoped=true&"
import script from "./tiktok.vue?vue&type=script&lang=js&"
export * from "./tiktok.vue?vue&type=script&lang=js&"
import style0 from "./tiktok.vue?vue&type=style&index=0&id=0d8b5473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b5473",
  null
  
)

export default component.exports